// export const hasPermission = (checkPermission) => {
//     let permissions = [];
//     let type = false;
//     if (localStorage.getItem('hasPermission')) {
//         permissions = JSON.parse(localStorage.getItem('hasPermission'));
//         type = permissions.indexOf(checkPermission);
//     }
//     return type ===-1 ? true : false;
// }

export const hasPermission = (checkPermission) => {
  let permissions = [];
  let type = false;
  for (var i = 0, j = checkPermission.length; !type && i < j; i++) {
    permissions = JSON.parse(localStorage.getItem("hasPermission"));
    if (
      localStorage.getItem("hasPermission") &&
      permissions.indexOf(checkPermission[i]) > -1
    ) {
      type = false;
    } else {
      type = true;
    }
  }
  return type;
};

/**
 * @desc To be used for showing or hiding sections.
 * @param {*} checkPermissions
 * @returns
 */
export const hasPermissions = (checkPermissions = []) => {
  let permissions = JSON.parse(localStorage.getItem("hasPermission")) || [];
  let hasAccess = false;
  checkPermissions.map((permission) => {
    if (permissions.indexOf(permission) > -1) hasAccess = true;
    // return permission;
  });
  return hasAccess;
};
